import { getCurrentSummaryData, getSummaryKpiSelected, getTableLoading } from "../../../selectors";
import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
import { Col, Row, Dropdown, Menu, Icon } from "antd";
import { getDimensions } from "../Dimension/Dimensions";
import Spinner from "../../../components/Spinner";
import { TYPE_SORT, SOURCE, SOURCES_LIST } from "./constants";
import html2canvas from "html2canvas";
import "./MultiDimensionsView.css";
import moment from "moment";
import FileSaver from "file-saver";
const MAX_ITEMS_PER_FILE = 15;
const HEIGHT_ELEMENT = 100;
const WIDTH_ELEMENT = 1000;
const TITLE_HEIGHT = 100;

const processData = (rawData, typeSort, source) => {
  const bySource = rawData[source] || {};
  const dataBySource = bySource.data || [];

  dataBySource.sort((a, b) => {
    if (typeSort === TYPE_SORT.ALPHABETICALLY) {
      if (a.dim_value > b.dim_value) return 1;
      else return -1;
    } else if (typeSort === TYPE_SORT.INCREASING) {
      if (a.value > b.value) return 1;
      else return -1;
    } else {
      if (a.value < b.value) return 1;
      else return -1;
    }
  });
  return bySource;
};
const drawItem = (ctx, item, i) => {
  ctx.textAlign = "start";
  ctx.fillStyle = "#000000";
  ctx.font = "normal 20px Arial";
  ctx.fillText(`${item.dim_value}`, 20, 40 + i * HEIGHT_ELEMENT);
  ctx.font = "bold 20px Arial";
  ctx.fillText(`${(Math.round(item.value * 10) / 10).toFixed(1)} %`, (2 * WIDTH_ELEMENT) / 3, 40 + i * HEIGHT_ELEMENT);
  ctx.font = "normal 20px Arial";
  ctx.fillText(`${item.v}/${item.n} `, (2 * WIDTH_ELEMENT) / 3 + 100, 40 + i * HEIGHT_ELEMENT);
  ctx.fillStyle = "#60A2FF";
  ctx.fillRect(WIDTH_ELEMENT / 3, 20 + i * HEIGHT_ELEMENT, item.value * 3, 20);
  ctx.fillStyle = "#F5F5F5";
  ctx.fillRect(WIDTH_ELEMENT / 3 + item.value * 3, 20 + i * HEIGHT_ELEMENT, 300 - item.value * 3, 20);
};

const MultiDimensionsView = props => {
  const data = props.data || {};
  const period = props.period || [];
  const [typeSort, setTypeSort] = useState(TYPE_SORT.ALPHABETICALLY);
  const [source, setSource] = useState(SOURCE.SECTOR);
  const [bySource, setBySource] = useState(processData(data, typeSort, source));

  useEffect(() => {
    setBySource(processData(data, typeSort, source));
  }, [data, typeSort, source]);
  const keysList = SOURCES_LIST.filter(item => Object.keys(data).findIndex(dataSource => dataSource === item.key) > -1);

  const selectedSource = keysList.find(item => item.key === source) || {};

  const title = selectedSource.title;
  const sourceLabel = selectedSource.sourceLabel;
  const kpi = props.kpi || {};

  return (
    <Row gutter={16} style={{ height: "100%" }}>
      {props.loading ? <Spinner style={{ top: 100 }} /> : null}
      <Col>
        <Row gutter={16}>
          <Col span={19}>
            <h2 className="p-page-subtitle p-txt-center">{title}</h2>
          </Col>
          <Col span={1}>
            {!props.loading && (
              <div
                onClick={() => {
                  if (bySource.format === "%") {
                    const dataArray = bySource.data || [];
                    const key_index = keysList.findIndex(key => source === key.key);

                    const max_items_per_file = Math.min(MAX_ITEMS_PER_FILE, dataArray.length);
                    const nb_files = Math.ceil(dataArray.length / max_items_per_file);
                    const nb_lines_per_file = Math.ceil(dataArray.length / nb_files);
                    for (let block = 0; block < nb_files; block++) {
                      const canvas = document.createElement("canvas");
                      canvas.width = WIDTH_ELEMENT;
                      canvas.height = HEIGHT_ELEMENT * nb_lines_per_file + TITLE_HEIGHT;
                      const ctx = canvas.getContext("2d");
                      ctx.fillStyle = "#FFFFFF";
                      ctx.fillRect(0, 0, canvas.width, canvas.height);
                      ctx.fillStyle = "#000000";
                      ctx.font = "bold 26px Arial";
                      ctx.textAlign = "center";
                      ctx.fillText(
                        ` ${kpi.long_label} / ${keysList[key_index].title} du ${moment(period[0]).format(
                          "DD.MM.YYYY"
                        )} au ${moment(period[1]).format("DD.MM.YYYY")} (${block + 1}/${nb_files})`,
                        WIDTH_ELEMENT / 2,
                        TITLE_HEIGHT / 2
                      );

                      ctx.translate(0, TITLE_HEIGHT);
                      for (
                        let line = block * nb_lines_per_file;
                        line < (block + 1) * nb_lines_per_file && line < dataArray.length;
                        line++
                      ) {
                        const i = line - block * nb_lines_per_file;
                        const item = dataArray[line];
                        drawItem(ctx, item, i);
                      }

                      FileSaver.saveAs(
                        canvas.toDataURL(),
                        `${block + 1}-${kpi.long_label}_${keysList[key_index].title}_du_${moment(period[0]).format(
                          "DD-MM-YYYY"
                        )}_au_${moment(period[1]).format("DD-MM-YYYY")}_progressbar.png`
                      );
                    }
                  } else {
                    html2canvas(document.getElementById("multidim2"), {
                      height: document.getElementById(`multidim2`).offsetHeight,
                      width: document.getElementById(`multidim2`).offsetWidth,
                      onclone: document => {
                        // document.getElementById("multidim2").style.overflowX = "visible";
                        // document.getElementById("multidim2").style.overflowY = "visible";
                        document.getElementById(`multidim2`).style.margin = 0;
                        document.getElementById(`multidim2`).style.padding = 0;
                      }
                    }).then(function(canvasToCopy) {
                      const canvas = document.createElement("canvas");
                      const ctx = canvas.getContext("2d");
                      canvas.width = canvasToCopy.width;
                      canvas.height = canvasToCopy.height + TITLE_HEIGHT * 1.5;
                      ctx.fillStyle = "#FFFFFF";
                      ctx.fillRect(0, 0, canvas.width, canvas.height);
                      ctx.fillStyle = "#000000";
                      ctx.font = "bold 13px Arial";
                      ctx.textAlign = "center";
                      ctx.fillText(
                        ` ${kpi.long_label} / ${title} du ${moment(period[0]).format("DD.MM.YYYY")} au ${moment(
                          period[1]
                        ).format("DD.MM.YYYY")}`,
                        canvas.width / 2,
                        TITLE_HEIGHT / 2
                      );
                      ctx.drawImage(canvasToCopy, 0, TITLE_HEIGHT);

                      FileSaver.saveAs(
                        canvas.toDataURL(),
                        `${kpi.long_label}_${title}_du_${moment(period[0]).format("DD-MM-YYYY")}_au_${moment(
                          period[1]
                        ).format("DD-MM-YYYY")}_progressbar.png`
                      );
                    });
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                <Icon type="camera"></Icon>
              </div>
            )}
          </Col>
          <Col span={1}>
            <Dropdown
              overlay={
                <Menu
                  style={{ width: 200 }}
                  onClick={({ key }) => {
                    setTypeSort(key);
                  }}
                >
                  {TYPE_SORT.INCREASING !== typeSort && (
                    <Menu.Item key={TYPE_SORT.INCREASING}>Trier par ordre croissant</Menu.Item>
                  )}
                  {TYPE_SORT.DECREASING !== typeSort && (
                    <Menu.Item key={TYPE_SORT.DECREASING}>Trier par ordre décroissant</Menu.Item>
                  )}
                  {TYPE_SORT.ALPHABETICALLY !== typeSort && (
                    <Menu.Item key={TYPE_SORT.ALPHABETICALLY}>Trier par ordre alphabétique</Menu.Item>
                  )}
                </Menu>
              }
            >
              <div>
                <Icon type="bar-chart" style={{}} />
              </div>
            </Dropdown>
          </Col>
          <Col span={1}>
            <Dropdown
              overlay={
                <Menu
                  style={{ width: 200 }}
                  onClick={({ key }) => {
                    setSource(key);
                  }}
                >
                  {keysList
                    .filter(item => item.key !== source)
                    .map(item => (
                      <Menu.Item key={item.key}>{item.title}</Menu.Item>
                    ))}
                </Menu>
              }
            >
              <div>
                <Icon type="database" />
              </div>
            </Dropdown>
          </Col>
        </Row>
        <Row
          gutter={16}
          style={{ marginTop: 20 }}
          /*className={
            Array.isArray(bySource.data) && bySource.data.length < 9 && window.screen.availHeight > 950
              ? "thick-bar"
              : ""
          }*/
        >
          {!props.loading && (
            <Col span={18} offset={3}>
              <div id="multidim2">{getDimensions(bySource, sourceLabel, 1, false, true, 0, [], 0, true)}</div>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};
const mapStateToProps = (state, ownProps) => {
  return {
    period: state.stats.period,
    data: getCurrentSummaryData(state),
    loading: getTableLoading(state),
    kpi: getSummaryKpiSelected(state)
  };
};
export default connect(mapStateToProps, null)(MultiDimensionsView);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Global/MultiDimensionsView.js